import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { Grid, GridColumn, Table, TableCell } from 'telia-front-react';

import InvoiceDetailsStore from '../../../stores/InvoiceDetailsStore';
import { ModalStore, ModalType } from '../../../stores/ModalStore';
import { formatAsCurrency } from '../../../util/FormatUtil';
import ButtonWithAnalytics from '../../common/ButtonWithAnalytics';
import MobileFullScreenNonClosableModal from '../../common/MobileFullScreenNonClosableModal';

import InvoiceLineUsagesTable from './InvoiceLineUsagesTable';

interface IInvoiceLineUsagesModalProps {
  invoiceDetailsStore?: InvoiceDetailsStore;
  modalStore?: ModalStore;
}

@inject('invoiceDetailsStore', 'modalStore')
@observer
export default class InvoiceLineUsagesModal extends React.Component<IInvoiceLineUsagesModalProps> {
  public render(): JSX.Element {
    const { lineName, lineSumWoVat, lineId } = this.props.invoiceDetailsStore.activeLineUsages;

    return (
      <MobileFullScreenNonClosableModal gaPage="invoices" gaGroup="Invoice line usages">
        <header>
          <Table>
            <tbody>
              <tr id="details-row-modal-usages">
                <TableCell width={10}>
                  <Grid noWrap={true} verticalGutter="none">
                    <GridColumn width={['min']}>
                      <ButtonWithAnalytics
                        gaEvent="Link - back to details view"
                        buttonProps={{
                          text: '',
                          icon: '#arrow-left',
                          type: 'primary',
                          onClick: () => this.props.modalStore.openModal(ModalType.InvoiceDetailsModal)
                        }}
                      />
                    </GridColumn>
                    <GridColumn width={['max']} align={['middle-xs']}>
                      {lineName}
                    </GridColumn>
                  </Grid>
                </TableCell>
                <TableCell width={2} className="text-right text-bold">
                  {formatAsCurrency(lineSumWoVat)}
                </TableCell>
              </tr>
            </tbody>
          </Table>
        </header>
        <InvoiceLineUsagesTable lineId={lineId} nestingIndexes={[]} />
      </MobileFullScreenNonClosableModal>
    );
  }
}
